<sb-comp-filter-overview [bookingEditorView]="true" [geoCull]="commercialRow.data.geoCull" [maxSize]="true"
                         [playerCull]="commercialRow.data.playerCull"
                         [timeCull]="commercialRow.data.timeCull"></sb-comp-filter-overview>
